/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleCategoryData
 */
export interface VehicleCategoryData {
    /**
     * 
     * @type {string}
     * @memberof VehicleCategoryData
     */
    vehicleCategory: VehicleCategoryDataVehicleCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleCategoryData
     */
    buildSeries: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    excludeElectric: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    isBookable: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleCategoryData
     */
    minimumAge: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    meetsAgeRequirement: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    isElectric: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    isAutomatic: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCategoryData
     */
    isHybrid: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleCategoryData
     */
    seats: number;
}


/**
 * @export
 */
export const VehicleCategoryDataVehicleCategoryEnum = {
    XS: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    XSC: 'XSC',
    SC: 'SC',
    MC: 'MC',
    LC: 'LC',
    XSE: 'XSE',
    SE: 'SE',
    ME: 'ME',
    LE: 'LE',
    XL: 'XL'
} as const;
export type VehicleCategoryDataVehicleCategoryEnum = typeof VehicleCategoryDataVehicleCategoryEnum[keyof typeof VehicleCategoryDataVehicleCategoryEnum];


/**
 * Check if a given object implements the VehicleCategoryData interface.
 */
export function instanceOfVehicleCategoryData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "vehicleCategory" in value;
    isInstance = isInstance && "buildSeries" in value;
    isInstance = isInstance && "excludeElectric" in value;
    isInstance = isInstance && "isBookable" in value;
    isInstance = isInstance && "minimumAge" in value;
    isInstance = isInstance && "meetsAgeRequirement" in value;
    isInstance = isInstance && "isElectric" in value;
    isInstance = isInstance && "isAutomatic" in value;
    isInstance = isInstance && "isHybrid" in value;
    isInstance = isInstance && "seats" in value;

    return isInstance;
}

export function VehicleCategoryDataFromJSON(json: any): VehicleCategoryData {
    return VehicleCategoryDataFromJSONTyped(json, false);
}

export function VehicleCategoryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCategoryData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vehicleCategory': json['vehicleCategory'],
        'buildSeries': json['buildSeries'],
        'excludeElectric': json['excludeElectric'],
        'isBookable': json['isBookable'],
        'minimumAge': json['minimumAge'],
        'meetsAgeRequirement': json['meetsAgeRequirement'],
        'isElectric': json['isElectric'],
        'isAutomatic': json['isAutomatic'],
        'isHybrid': json['isHybrid'],
        'seats': json['seats'],
    };
}

export function VehicleCategoryDataToJSON(value?: VehicleCategoryData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vehicleCategory': value.vehicleCategory,
        'buildSeries': value.buildSeries,
        'excludeElectric': value.excludeElectric,
        'isBookable': value.isBookable,
        'minimumAge': value.minimumAge,
        'meetsAgeRequirement': value.meetsAgeRequirement,
        'isElectric': value.isElectric,
        'isAutomatic': value.isAutomatic,
        'isHybrid': value.isHybrid,
        'seats': value.seats,
    };
}

